export default "__VITE_ASSET__41790b9e__"